/**
 * @author Andres Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import IBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades/entidades/bodegasTiposPropiedades';
import { AnyAction } from 'redux';

export interface IEstadoBodegasTiposPropiedades {
    estadoFormulario: boolean;
    entidadBodegasTiposPropiedades: IBodegasTiposPropiedades | null;
    recargarTabla: boolean;
    tipoFormulario: TipoFormulario;
}

export const estadoIncial: IEstadoBodegasTiposPropiedades = {
    entidadBodegasTiposPropiedades: null,
    estadoFormulario: false,
    recargarTabla: false,
    tipoFormulario: TipoFormulario.Creacion,
};

export enum acciones {
    CAMBIAR_ESTADO_FORMULARIO = 'CAMBIAR_ESTADO_FORMULARIO',
    RECARGAR_TABLA = 'RECARGAR_TABLA',
}

export const reductor = (estado: IEstadoBodegasTiposPropiedades, { type, payload }: AnyAction) => {
    switch (type) {
        case 'CAMBIAR_ESTADO_FORMULARIO': {
            return {
                ...estado,
                entidadBodegasTiposPropiedades: payload ? payload.entidadBodegasTiposPropiedades : null,
                estadoFormulario: !estado.estadoFormulario,
                tipoFormulario: payload ? payload.tipoFormulario : estado.tipoFormulario,
            };
        }
        case 'RECARGAR_TABLA':
            return {
                ...estado,
                recargarTabla: !estado.recargarTabla,
            };

        default:
            return estado;
    }
};
